import { useIntraDayProfileConfigSlice } from 'widgets/intraDayProfile/store/configuration/configSlice';

export function useIntradayProfileLegendStatus() {
    const { config } = useIntraDayProfileConfigSlice();

    const {
        hideExpectedVolumeLegend,
        hideActualTradedVolumeLegend,
        hideCumulativeActualVolumeLegend,
        hideCumulativeExpectedVolumeLegend,
        hideSpreadLegend,
        hideVolatilityLegend,
        hideAuctionVolumeLegend,
    } = config;

    const hidingAllLegends =
        hideExpectedVolumeLegend &&
        hideActualTradedVolumeLegend &&
        hideCumulativeActualVolumeLegend &&
        hideCumulativeExpectedVolumeLegend &&
        hideSpreadLegend &&
        hideVolatilityLegend &&
        hideAuctionVolumeLegend;

    const col1Rows = countVisible(
        hideExpectedVolumeLegend,
        hideActualTradedVolumeLegend
    );
    const col2Rows = countVisible(
        hideCumulativeExpectedVolumeLegend,
        hideCumulativeActualVolumeLegend
    );

    const individualCount = countVisible(
        hideSpreadLegend,
        hideVolatilityLegend,
        hideAuctionVolumeLegend
    );

    const first2ColRows = Math.max(col1Rows, col2Rows);

    const col3Rows =
        individualCount > 1
            ? first2ColRows === 2
                ? // The 3rd and 4th cols can wrap one of the legends
                  2
                : 1
            : individualCount > 0
            ? 1
            : 0;
    const col4Rows = individualCount > 2 ? 1 : 0;

    const rows = Math.max(col1Rows, col2Rows, col3Rows, col4Rows);

    const columns = [col1Rows, col2Rows, col3Rows, col4Rows].filter(
        (r) => r > 0
    ).length;

    return { hidingAllLegends, rows, columns };
}

function countVisible(...hiddenValues: boolean[]) {
    let rows = hiddenValues.length;
    for (const hiddenValue of hiddenValues) {
        if (hiddenValue) {
            rows--;
        }
    }
    return rows;
}
